import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllLocations } from "services/locationService";

const LocationLinks = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      const data = await getAllLocations();
      const activeLocations = data.filter((loc) => loc.active === true);
      setLocations(activeLocations);
    };

    fetchLocations();
  }, []);

  // Group locations by name
  const groupedLocations = locations.reduce((acc, loc) => {
    acc[loc.name] = acc[loc.name] ? [...acc[loc.name], loc] : [loc];
    return acc;
  }, {});

  return (
    <div className="backdrop-blur-md rounded-sm w-full text-left">
      <h3 className="text-lg font-semibold text-gray-400 mb-4 border-b border-amber-400 pb-2">
        S'inscrire aux hebdos
      </h3>

      <div className="text-sm">
        {Object.entries(groupedLocations).map(([name, group]) => (
          <div key={name}>
            {group.length === 1 ? (
              <Link
                to={`/locations/${group[0].id}`}
                className="block p-2 bg-opacity-70 hover:bg-amber-500 hover:text-white transition duration-200 text-white font-semibold shadow-xl rounded-sm"
              >
                {name}
              </Link>
            ) : (
              <div className="shadow-xl p-2 rounded-sm">
                <div className="font-semibold text-white mb-2">
                  {name}
                </div>
                <div className="flex flex-col space-y-1 pl-3">
                  {group.map((loc) => (
                    <Link
                      key={loc.id}
                      to={`/locations/${loc.id}`}
                      className="block p-2 text-gray-300 hover:bg-amber-500 hover:text-white transition duration-200 rounded-sm"
                    >
                      {loc.table || "Sans table"}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationLinks;
